import { List } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import NavBarItem, { NavBarItemObj } from './NavBarItem';

interface NavTraySectionProps {
  toggleMenu: <T>(e: React.MouseEvent<T>) => void;
  closeMenu: <T>(e: React.MouseEvent<T>) => void;
  color: string;
  subItems?: NavBarItemObj[];
  name: string;
  openByDefault?: boolean;
  className?: string;
}

const StyledList = styled(List)<{ $backgroundColor: string }>`
  padding: 0px !important;
  background-color: ${(props) => props.$backgroundColor};
`;

const NavTraySection = (props: NavTraySectionProps) => {
  const {
    toggleMenu,
    closeMenu,
    subItems,
    name,
    color,
    openByDefault,
    className,
  } = props;
  return (
    <StyledList $backgroundColor={color} style={{ color: '#ffffff' }}>
      <NavBarItem
        className={className}
        toggleMenu={toggleMenu}
        closeMenu={closeMenu}
        key={name}
        name={name}
        subItems={subItems}
        root
        level={0}
        color={color}
        openByDefault={openByDefault}
      />
    </StyledList>
  );
};

export default NavTraySection;
